import { computed } from 'vue';
import { SEARCH_KEYS } from '@/utils/order-serach.js';

export function useOrderFilter(ordersRef, searchTextRef, orderTypeRef = null) {
  // Get value from ref if needed
  const typeKey = orderTypeRef?.value ?? orderTypeRef;

  // Deep get with support for "a.b.c" and arrays (hotOrders[])
  const getByPath = (obj, path) => {
    if (!path) return obj;

    return path.split('.').reduce((current, key) => {
      if (current == null) return undefined;
      if (Array.isArray(current)) {
        return current.flatMap(item => getByPath(item, key));
      }
      return current[key];
    }, obj);
  };

  // Extract all scalar values from a potentially nested structure
  const extractScalars = (value) => {
    if (value == null) return [];

    if (Array.isArray(value)) {
      return value.flatMap(extractScalars);
    }

    if (typeof value === 'object') {
      return Object.values(value).flatMap(extractScalars);
    }

    return [value];
  };

  const filtered = computed(() => {
    const term = (searchTextRef.value || '').trim().toLowerCase();
    if (!term) return ordersRef.value || [];

    const orders = ordersRef.value || [];
    if (!orders.length) return [];

    const hasSpecificType = typeKey && SEARCH_KEYS[typeKey];
    const paths = hasSpecificType ? SEARCH_KEYS[typeKey] : null;

    return orders.filter(order => {
      if (paths) {
        // Precise mode: only search specified paths
        return paths.some(path => {
          const values = extractScalars(getByPath(order, path));
          return values.some(v => String(v).toLowerCase().includes(term));
        });
      } else {
        // Full search mode: search EVERYTHING
        const allValues = extractScalars(order);
        return allValues.some(v => String(v).toLowerCase().includes(term));
      }
    });
  });

  return { filtered };
}